import signup, { guestSignup } from "./signup";
import facebookSignup from "./facebookSignup";
import { socialProviders } from "../socialProviders";

//revisit below module and make it dynamic

export function getSignupMethod(signupConfig) {
  if (isNormalSignup(signupConfig)) {
    return signup;
  } else if (isFacebookSignup(signupConfig)) {
    return facebookSignup;
  } else if (isOTPSignup(signupConfig)) {
    return signup;
  } else if (isSignupWithSSO(signupConfig)) {
    return signup;
  } else if (isGuestSignup(signupConfig)) {
    return guestSignup;
  }
}

function isNormalSignup(config) {
  return !!(config.username && config.password);
}
function isSignupWithSSO(config) {
  return config.service === "signupWithSSO" && config.token;
}

function isGuestSignup(config) {
  return config.service === "guestSignup" && config.uniqueReference;
}
function isFacebookSignup(config) {
  return config.provider === socialProviders.FACEBOOK;
}

function isOTPSignup(config) {
  return config && config.otp;
}
